import { useMutation, useQueryClient } from '@tanstack/react-query';

import { session } from '@/shared/session/session';

import { authApi } from '../api/auth-api';
import { isTwoFactorChallenge } from '../schemas/two-factor-rules';

/** Exchanges Google's code; like login it may answer with a two-factor challenge instead. */
export function useGoogleCallback() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: authApi.googleCallback,
    meta: { silentError: true },
    onSuccess: async (result) => {
      if (!isTwoFactorChallenge(result)) await session.refreshSession(queryClient);
    },
  });
}
